import { useRef, useEffect, useState } from 'react';

import { motion, useScroll, useTransform } from 'framer-motion';

import useScrollVelocityX from '../../hooks/useScrollVelocityX';

import useGsapHero from '../../hooks/useGsapHero';

import { BlurSplitText, ScrambleReveal } from '../TextEffects';

import './HeroSection.css';



const marqueeWords = [

  'DESIGN', 'MOTION', 'CRAFT', 'CODE', 'SYSTEMS',

];



const HeroSection = () => {

  const ref = useRef(null);

  const inView = useGsapHero(ref);

  const { scrollYProgress } = useScroll({

    target: ref,

    offset: ['start start', 'end start'],

  });



  const contentY = useTransform(scrollYProgress, [0, 1], [0, -120]);

  const contentOpacity = useTransform(scrollYProgress, [0, 0.7], [1, 0]);

  const marqueeX = useScrollVelocityX(-0.9);



  const [time, setTime] = useState('');



  useEffect(() => {

    const tick = () => {

      const now = new Date();

      const opts = { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false };

      setTime(new Intl.DateTimeFormat('en-GB', opts).format(now));

    };

    tick();

    const id = setInterval(tick, 1000);

    return () => clearInterval(id);

  }, []);



  return (

    <section ref={ref} className="hero" data-testid="hero-section">

      <div className="hero-strip">

        <span className="hero-strip-item gsap-reveal">

          <span className="hero-dot" aria-hidden="true" />

          <ScrambleReveal

            text="AVAILABLE FOR SELECT COLLABORATIONS — 2026"

            externalInView={inView}

            delay={0.2}

          />

        </span>

        <span className="hero-strip-item hero-strip-right tabular gsap-reveal">

          {time}

        </span>

        <div className="hero-strip-line" aria-hidden="true" />

      </div>



      <motion.div className="hero-stage" style={{ y: contentY, opacity: contentOpacity }}>

        <div className="hero-pretitle gsap-reveal">

          <span className="hero-index">(001)</span>

          <span className="hero-divider" />

          <ScrambleReveal text="INDEX / HOMEPAGE" externalInView={inView} delay={0.35} />

        </div>



        <h1 className="hero-statement" aria-label="Explorations in advanced form.">

          <BlurSplitText

            text="Explorations"

            as="span"

            className="hero-line"

            externalInView={inView}

            delay={0.4}

            stagger={0.09}

          />

          <motion.span

            className="hero-line hero-line-marquee gsap-reveal"

            aria-hidden="true"

          >

            <span className="hero-marquee-mask">

              <motion.span className="hero-marquee-track" style={{ x: marqueeX }}>

                {[...marqueeWords, ...marqueeWords].map((w, i) => (

                  <span key={i} className="hero-marquee-word">

                    <span className="hero-marquee-text">{w}</span>

                    <span className="hero-marquee-sep" aria-hidden="true">✦</span>

                  </span>

                ))}

              </motion.span>

            </span>

          </motion.span>



          <span className="hero-line">

            <BlurSplitText text="in advanced" externalInView={inView} delay={0.65} stagger={0.09} />

            {' '}

            <em className="hero-em">

              <BlurSplitText text="form." externalInView={inView} delay={0.85} stagger={0.08} />

            </em>

          </span>

        </h1>



        <p className="hero-sub">
          Andrea Fagioli — independent designer & creative technologist
          <br className="hero-sub-break" />
          working across visual identity, web development and AI-driven experiences.
        </p>

      </motion.div>



      <motion.div className="hero-rail gsap-reveal" style={{ opacity: contentOpacity }}>

        <div className="hero-rail-block">

          <span className="hero-rail-label">Practice</span>

          <span className="hero-rail-value">Independent · Since 2019</span>

        </div>



        <a href="#reel" className="hero-rail-scroll" aria-label="Scroll to reel">

          <span className="hero-rail-label">Scroll</span>

          <motion.span

            className="hero-rail-line"

            animate={{ scaleY: [0, 1, 0] }}

            transition={{ duration: 2.2, repeat: Infinity, ease: 'easeInOut' }}

            style={{ transformOrigin: 'top' }}

            aria-hidden="true"

          />

        </a>



        <div className="hero-rail-block hero-rail-block-right">

          <span className="hero-rail-label">Currently</span>

          <span className="hero-rail-value">Creative Technologist</span>

        </div>

      </motion.div>



      <div className="hero-grain" aria-hidden="true" />

    </section>

  );

};



export default HeroSection;

